// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__Q4PBM","title":"Images90_title__2o4fc","images":"Images90_images__3ju1F"};